module.exports = __webpack_public_path__ + "9c4bedeee9074a7ab438ff0e548d0fba.svg";